import React from 'react';
import Chart from 'react-apexcharts';
import styled from 'styled-components';
export const StyledChart = styled(Chart)`
  canvas {
    width: 100% !important;
    height: 150 !important;
  }
  .apexcharts-tooltip {
    color: #fff;
    padding: 5px;
  }
`;
const options = {
  responsive: [{
    breakpoint: undefined,
    options: {}
  }],
  chart: {
    type: 'bar',
    width: '100%',
    toolbar: {
      show: false
    }
  },
  tooltip: {
    enabled: true,
    theme: 'dark',
    custom: function ({
      series,
      seriesIndex,
      dataPointIndex,
      w
    }) {
      return '<div class="arrow_box">' + '<span>' + w.globals.labels[dataPointIndex] + ': ' + series[seriesIndex][dataPointIndex] + '</span>' + '</div>';
    },
    style: {
      fontSize: '12px',
      fontFamily: 'OpenSans-Regular',
      color: 'red'
    }
  },
  plotOptions: {
    bar: {
      horizontal: true,
      distributed: true,
      borderRadius: 0,
      barHeight: '65%',
      dataLabels: {
        position: 'top'
      }
    }
  },
  legend: {
    show: false
  },
  colors: ['#067FDB', '#067FDB'],
  dataLabels: {
    enabled: true,
    style: {
      fontSize: '10px',
      fontWeight: 600,
      colors: ['#000']
    },
    offsetX: 20
  },
  grid: {
    yaxis: {
      lines: {
        show: false
      }
    }
  },
  xaxis: {
    type: 'Resources',
    categories: ['Unused Access', 'Access Spread'],
    labels: {
      show: true,
      showDuplicates: false,
      trim: false
    },
    axisTicks: {
      show: false
    },
    min: 0,
    max: 100,
    tickAmount: 1
  }
};

const ResourceDistribution = ({
  ResourceDistributionData
}) => {
  return ResourceDistributionData && /*#__PURE__*/React.createElement(StyledChart, {
    options: options,
    series: ResourceDistributionData.series,
    type: "bar",
    width: "100%",
    height: "150"
  });
};

export default ResourceDistribution;